import { useEffect, useMemo, useState } from 'react';
import { creerClient, type Client } from '../../api/client.js';
import type { Ecran } from '../../api/contrat.js';
import { ETAT_CHARGEMENT, type EtatRequete } from '../../api/requete.js';
import { useClientExterne } from '../clerc/contexte.js';
import { chargerEspaceNotaire, type DonneesNotaire } from './chargement.js';
import { VueEspaceNotaire } from './VueNotaire.js';

/**
 * Dossier à lire : `?dossier=` dans l’adresse (lien envoyé par le Cabinet MAAT). Sans lui, aucun identifiant n’est inventé :
 * l’ancien repli sur le dossier d’exemple du contrat partait au serveur en production (PER-6-02).
 */
export function dossierDemande(recherche: string): string {
  const demande = new URLSearchParams(recherche).get('dossier');
  return demande ?? '';
}

/** Espace du notaire (X12) : lecture seule, un dossier à la fois. */
export function EspaceNotaire(_props: { ecran: Ecran }) {
  const fourni = useClientExterne();
  const client: Client = useMemo(() => fourni ?? creerClient({ fetch: (...a) => globalThis.fetch(...a) }), [fourni]);
  const [etat, setEtat] = useState<EtatRequete<DonneesNotaire>>(ETAT_CHARGEMENT as EtatRequete<DonneesNotaire>);

  useEffect(() => {
    let actif = true;
    const recherche = typeof window === 'undefined' ? '' : window.location.search;
    const dossierId = dossierDemande(recherche);
    if (dossierId === '') {
      setEtat({ etat: 'vide' });
      return;
    }
    void chargerEspaceNotaire(client, dossierId).then((e) => {
      if (actif) setEtat(e);
    });
    return () => {
      actif = false;
    };
  }, [client]);

  return <VueEspaceNotaire etat={etat} />;
}
